import React from 'react';
import * as Const from '../../utils/Const';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import Button from '@mui/material/Button';
import Sidebar from '../../components/sidemenu/Sidebar';
import { DownloadCSVTypes } from '../../utils/Const';
import { Checkbox, FormControlLabel } from '@mui/material';

export function DatadownloadView(props: {
  fromDate: Date | null;
  toDate: Date | null;
  setFromDate: (date: Date | null) => void;
  setToDate: (date: Date | null) => void;
  selectedCsvTypes: string[];
  setSelectedCsvTypes: (key: string[]) => void;
  handleDownload: () => void;
  downloadErrorMessage: string;
}) {
  const { setFromDate, setToDate, setSelectedCsvTypes } = props;

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const checked = event.target.checked;
    const tempSelectedCsvTypes = props.selectedCsvTypes || [];
    const newSelectedCsvTypes = checked
      ? [...tempSelectedCsvTypes, value]
      : tempSelectedCsvTypes.filter((v) => v !== value);
    setSelectedCsvTypes(newSelectedCsvTypes);
  };

  return (
    <>
      <Sidebar />
      <div
        style={{
          marginLeft: 40,
          width: 'calc(100% - 40px)',
          transition: 'width 0.3s, margin-left 0.3s',
        }}
        className="grid grid-cols-1"
      >
        <div
          style={{
            position: 'fixed',
            top: '75px',
            zIndex: 999,
            width: 'calc(100% - 40px)',
          }}
        >
          <div className="p-4">
            <div
              className="p-2"
              style={{
                borderWidth: '1px',
                backgroundColor: `${Const.SearchItemColor}`,
              }}
            >
              <div className="flex 3xl:flex-row flex-col gap-8 p-2 mb-0">
                <div className="flex items-center">
                  <label className="text-base font-bold">{Const.LabelStartDatetimeUtc}</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      format="yyyy/MM/dd HH:mm"
                      value={props.fromDate}
                      onChange={props.setFromDate}
                      ampm={false}
                      slotProps={{
                        actionBar: { actions: ['accept'] },
                        textField: {
                          size: 'small',
                          style: {
                            borderColor: `${Const.SearchItemBorderColor}`,
                            width: '200px',
                          },
                        },
                      }}
                      slots={{
                        actionBar: (props) => (
                          <>
                            <Button onClick={() => setFromDate(new Date())}>現在時刻</Button>
                            {props.actions?.map((action) => {
                              switch (action) {
                                case 'accept':
                                  return (
                                    <Button
                                      key="accept"
                                      onClick={() => {
                                        props.onAccept?.();
                                      }}
                                    >
                                      OK
                                    </Button>
                                  );
                                default:
                                  return null;
                              }
                            })}
                          </>
                        ),
                      }}
                    />
                  </LocalizationProvider>
                  <label className="text-base font-bold ml-4">{Const.LabelToDatetimeUtc}</label>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                      format="yyyy/MM/dd HH:mm"
                      value={props.toDate}
                      onChange={props.setToDate}
                      ampm={false}
                      slotProps={{
                        actionBar: { actions: ['accept'] },
                        textField: {
                          size: 'small',
                          style: {
                            borderColor: `${Const.SearchItemBorderColor}`,
                            width: '200px',
                          },
                        },
                      }}
                      slots={{
                        actionBar: (props) => (
                          <>
                            <Button onClick={() => setToDate(new Date())}>現在時刻</Button>
                            {props.actions?.map((action) => {
                              switch (action) {
                                case 'accept':
                                  return (
                                    <Button key="accept" onClick={props.onAccept}>
                                      OK
                                    </Button>
                                  );
                                default:
                                  return null;
                              }
                            })}
                          </>
                        ),
                      }}
                    />
                  </LocalizationProvider>
                </div>
                <div className="items-center">
                  <label className="text-base font-bold">{'ダウンロード対象：'}</label>
                  {DownloadCSVTypes.map((csvType) => {
                    return (
                      <FormControlLabel
                        key={csvType.key}
                        control={
                          <Checkbox
                            value={csvType.value}
                            checked={props.selectedCsvTypes.includes(csvType.value)}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label={csvType.value}
                      />
                    );
                  })}
                </div>
                <div>
                  <Button variant="contained" onClick={props.handleDownload}>
                    {Const.LabelCsvDownload}
                  </Button>
                </div>
                <div>
                  {props.downloadErrorMessage && (
                    <p style={{ color: 'red', marginTop: '8px' }}>{props.downloadErrorMessage}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DatadownloadView;
